var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",style:(_vm.computeStyle)},[_vm._v(" "+_vm._s(_vm.text)+" "),(!_vm.text && _vm.iconName)?_c('maple-icon',{attrs:{"size":_vm.iconSize,"name":_vm.iconName,"color":_vm.iconColor}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }